export default "__VITE_ASSET__r4sv0iWk__"